<!-- TODO: VERY IMPORTANT: Since PrimeNG's Growl is deprecated, toasts should be used instead -->

<!--
<p-growl [(value)]="_msgs" [sticky]="false" [life]="2000"></p-growl>-->

<p-toast key="_msgs" ></p-toast>
